import { types, flow } from "mobx-state-tree"
import { fileUploadHistoryBusiness } from "businesses/file-upload-history-business"
import { storageName } from "shared/constants/storage-constant"
import * as StorageHelper from "utils/storage-helper"

const FileUploadHistoryStore = types
  .model({
    data: types.optional(types.frozen(), []),
    isLoading: types.maybeNull(types.boolean),
  })
  .actions(self => ({
    setData(data) {
      self.data = data
    },
  }))
  .actions(self => ({
    loadData: flow(function* (userName, moduleName) {
      const searchParams = {
        user_name: userName,
        type: moduleName,
      }
      self.isLoading = true
      const data = yield fileUploadHistoryBusiness.getData(searchParams)

      const company = StorageHelper.getStorage(storageName.activeCompany)

      self.setData(data.filter(x => x.Company == company))
      self.isLoading = false
    }),
    addData: flow(function* (data) {
      data.Company = StorageHelper.getStorage(storageName.activeCompany)
      const result = yield fileUploadHistoryBusiness.addData(data)
      return result
    }),
  }))
export default FileUploadHistoryStore
